import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import {
  Grid,
} from '@material-ui/core';
import DashboardWidget from '../Dashboard/components/Dashboard-Widget/Dashboard-Widget';
const useStyles = theme => ({
  root: {
    padding: theme.spacing(4)
  },
});

class Report1 extends Component {
  componentDidMount() {
    this.props.getAllTableCounts();
  }

  render() {
    // console.log('4444-37101 - Report1 = ', this.props );
    // console.log('4444-37102 - Report1 = ', this.state );
    return (
      <div className={this.props.classes.root}>
        <Grid
          container
          spacing={2}
        >

          <Grid
            item
            lg={6}
            sm={6}
            xl={3}
            xs={12}
          >
            {/* <Budget referralsCount={this.props.reports.referrals.pendingCount} /> */}
            <DashboardWidget
              title='Referrals Count'
              count={this.props.reports.referrals}
              link='/referrals/'
              icon={0}
            />
            <DashboardWidget
              title='Archived Referrals Count'
              count={this.props.reports.archivedreferrals}
              link='/archivedreferrals/'
              icon={2}
            />
          </Grid>
          <Grid
            item
            lg={6}
            sm={6}
            xl={3}
            xs={12}
          >
            {/* <TotalUsers clientsCount={this.props.reports.clients.pendingCount} /> */}
            <DashboardWidget
              title='Clients Count'
              count={this.props.reports.clients}
              link='/clients/'
              icon={1}
            />
            <DashboardWidget
              title='Archived Clients Count'
              count={this.props.reports.archivedclients}
              link='/archivedclients/'
              icon={2}
            />
          </Grid>

{/* 
          <Grid
            item
            // lg={3}
            lg={6}
            sm={6}
            xl={3}
            xs={12}
          > 
*/}



          <Grid
            item
            lg={6}
            sm={6}
            xl={3}
            xs={12}
          >
            {/* <TotalUsers postdischargesCount={this.props.reports.postdischarges.pendingCount} /> */}
            <DashboardWidget
              // title='add the 12 18 90 180 24 36 months and days here Post Discharges Count'
              title='Post Discharges Count'
              count={this.props.reports.postdischarges}
              link='/postdischarges/'
              icon={1}
            />
            <DashboardWidget
              title='Archived Post Discharges Count'
              count={this.props.reports.archivedpostdischarges}
              link='/archivedpostdischarges/'
              icon={2}
            />
          </Grid>
          <Grid
            item
            lg={6}
            sm={6}
            xl={3}
            xs={12}
          >
            {/* empty space for proper formating */}
          </Grid>

        </Grid>
      </div>
      );
  }
}

Report1.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object
};

export default withRouter( withStyles(useStyles)(Report1) );